<script>
import _ from 'lodash'
import moment from 'moment'
import RecordCountService from '@/request/count/record'
import Vue from 'vue'
import VCharts from 'v-charts'
Vue.use(VCharts)
export default {
  name: 'CountRecord',
  components: {},
  props: {
    date: {
      type: Object,
      default () {
        return {
          start: moment().startOf('day').valueOf(),
          end: moment().endOf('day').valueOf()
        }
      }
    },
    type: {
      type: String,
      default: 'atCount'
    },
    orgs: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      types: {
        'atCount': '在院',
        'admissionCount': '入院',
        'leaveCount': '出院'
      },
      dataLoading: false,
      chartData: {
        columns: ['name', '在院'],
        rows: []
      },
      settings: {
        label: {
          show: true,
          position: 'top'
        }
      },
      chartExtend: {
        yAxis: {
          minInterval: 1
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 40
            /* formatter: (value) => {
              return value.split('').join('\n')
            } */
          }
        }
      }
    }
  },
  computed: {},
  created: function () {
    this.chartData.columns = ['name', this.types[this.type]]
    this.loadData()
  },
  watch: {
    date () {
      this.loadData()
    },
    orgs () {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      let self = this
      if (_.isEmpty(self.orgs)) {
        self.chartData.rows = []
        return
      }
      if (!self.type) {
        self.type = 'atCount'
      }
      let oids = []
      let rows = []
      _.forEach(self.orgs, org => {
        oids.push(org.id)
        let item = _.cloneDeep(org)
        item[self.types[self.type]] = 0
        rows.push(item)
      })
      self.dataLoading = true
      RecordCountService.countOrg({
        start: self.date.start || moment().startOf('day').valueOf(),
        end: self.date.end || moment().endOf('day').valueOf(),
        oids: _.join(oids)
      }).then(res => {
        let list = res.result || []
        _.forEach(list, item => {
          let index = _.findIndex(rows, {'id': item.oid})
          if (index < 0) {
            return
          }
          rows[index][self.types[self.type]] = item[self.type]
        })
        self.chartData.rows = _.clone(rows)
      }).finally(() => {
        self.dataLoading = false
      })
    }
  },
  filters: {}
}
</script>

<template>
  <ve-histogram
    v-loading="dataLoading"
    :data="chartData"
    :extend="chartExtend"
    :legend-visible="false"
    legend-position="bottom"
    :settings="settings">
    <div class="data-empty" v-if="chartData.rows.length <= 0">没有数据😂</div>
  </ve-histogram>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.data-empty {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, .7);
  color: #888;
  font-size: 14px;
}
</style>
